import React from "react";

const NotificationsIcon = (props: any) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M2.9519 17.2299C2.70381 18.8563 3.81299 19.9851 5.17106 20.5477C10.3776 22.7046 17.623 22.7046 22.8296 20.5477C24.1877 19.9851 25.2968 18.8563 25.0487 17.2299C24.8963 16.2304 24.1423 15.3981 23.5838 14.5854C22.8521 13.5078 22.7795 12.3325 22.7793 11.082C22.7793 6.24954 18.8488 2.33203 14.0003 2.33203C9.15181 2.33203 5.22131 6.24954 5.22131 11.082C5.2212 12.3325 5.1485 13.5078 4.41687 14.5854C3.8583 15.3981 3.10437 16.2304 2.9519 17.2299Z" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.33301 22.168C9.86791 24.1807 11.7545 25.668 13.9997 25.668C16.2449 25.668 18.1314 24.1807 18.6663 22.168" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};

export default NotificationsIcon;
